import {useWorkspaceContext} from "../pages/Dashboard"
import {selectAllUnassignedArticleIds, selectUnassignedArticleIds} from "../reducers/unassignedArticlesEventsSlice"
import {useSelector} from "react-redux"
import {useMemo} from "react"

/**
 * Memoized selector hooks.
 *
 * Wraps factory selectors (e.g. `selectAllUnassignedArticleIds(workspaceId)`)
 * with `useMemo` so each consuming component gets a stable selector instance
 * keyed to its workspace context. Import these instead of calling factory
 * selectors directly in components.
 */

/**
 * Returns the memoized list of ALL unassigned article IDs for the current workspace.
 *
 * @returns {number[]}
 */
export function useAllUnassignedArticleIds() {
	const { workspaceId } = useWorkspaceContext()
	const selector = useMemo(() => selectAllUnassignedArticleIds(workspaceId), [workspaceId])
	return useSelector(selector)
}
/**
 * Returns the memoized list of unassigned article IDs for the current workspace.
 * Distinct from useAllUnassignedArticleIds, but IDK why...
 *
 * @returns {number[]}
 */
export function useUnassignedArticleIds() {
	const {workspaceId} = useWorkspaceContext()
	const selector = useMemo(() => selectUnassignedArticleIds(workspaceId), [workspaceId])
	return useSelector(selector)
}